import React, {Component} from 'react';
import { GrLinkedin } from "react-icons/gr";
import {AiFillGithub} from "react-icons/all";
import Resim from '../img/A.jpg'

class Anasayfa extends Component {
    render() {
        return (
            <div style={{marginTop:150,fontFamily:'Architects Daughter'}} className="row">
                <div className="col-sm-6">
                    <p style={{ textIndent:60,textAlign:"center",letterSpacing:3,fontSize:35}}>
                         Merhaba ben <span style={{color:"royalblue"}}>Ali.</span> Bilgisayar Mühendisiyim. Frontend alanında kendimi geliştiriyorum.
                </p><div style={{textAlign:"center"}}>
                    <a style={{fontSize:60}} href="https://www.linkedin.com/in/ali-r%C4%B1za-%C3%A7elebi-99a3a3181/"><GrLinkedin/></a>
                        <a style={{color:"black",fontSize:60,paddingLeft:40}} href="https://github.com/celebiali"><AiFillGithub/>
                        </a>
                    </div>
                </div>


        <div style={{textAlign:"center",marginTop:11}} className="col-sm-6">
            <img src={Resim} alt="logo" className="rounded-circle" height={300}/>
        </div>
            </div>
        );
    }
}

export default Anasayfa;